import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const FAQHeadingCss = css`
	text-align: center;
	margin: 0 auto;
	margin-top: 2rem;
`;

export const FAQSubtitleCss = css`
	text-align: center;
	margin-top: 2rem;
	margin-bottom: 4rem;
`;

export const Container = styled.div`
	> div.faqs {
		gap: var(--margin-3);

		@media ${Breakpoints.mobileLandscape} {
			margin-bottom: var(--padding-3);
		}
	}
`;

export const DeleteLottieContainer = styled.div`
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const CardContainer = styled.div`
	width: 65rem;
	@media ${Breakpoints.mobile} {
		width: 40rem;
	}
`;

export const CardBody = styled.div`
	display: flex;
	align-items: center;
	padding: 2rem 0;
	border-bottom: 1px solid var(--border-color);

	:first-of-type {
		padding-top: 0;
		padding-bottom: 2rem;
	}

	:last-of-type {
		border-bottom: none;
		padding-top: 2rem;
		padding-bottom: 0;
	}
`;

export const CardRow = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
`;

export const BlackText = styled.span`
	color: var(--black);
	font-weight: 500;
`;
